var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "600", persistent: _vm.isCheck || _vm.show },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticStyle: { "border-radius": "10px" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c("v-flex", { attrs: { "pt-4": "" } }, [
                    _c("img", {
                      staticStyle: {
                        margin: "0 auto",
                        width: "100px",
                        display: "block",
                        height: "100px",
                      },
                      attrs: {
                        src: _vm.isGood
                          ? "https://images.cloudclusters.io/3a9ecb99f1884b79905741113878d615/success.png"
                          : "https://images.cloudclusters.io/1fa7ac8a209e492895a86e67f414a8f6/waitingVerified.png",
                      },
                    }),
                  ]),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { "pb-4": "", "pt-4": "" },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "fs-4",
                          style: { color: _vm.isGood ? "#18b23d" : "#ffa700" },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.isGood
                                  ? _vm.$t(_vm.showGoodText)
                                  : _vm.$t(_vm.showNoGoodText)
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { "pb-3": "" },
                    },
                    [
                      _vm.isCheck || _vm.type === "check"
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "text-none",
                              attrs: {
                                depressed: "",
                                dark: "",
                                color: "#ffa700",
                              },
                              on: { click: _vm.linkToPage },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("btn_check[0]")) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.type === "membership" && !_vm.isGood
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "text-none",
                              attrs: {
                                depressed: "",
                                dark: "",
                                color: "#ffa700",
                                to: "/account/information",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("btn_check_billing[0]")) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.type === "membership" && _vm.isGood
                    ? _c(
                        "v-flex",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { "pb-3": "" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "text-none mr-5",
                              attrs: {
                                depressed: "",
                                dark: "",
                                color: _vm.isGood ? "#18b23d" : "#ffa700",
                                to: "/account/information",
                                title: _vm.$t("btn_details[1]"),
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("btn_details[0]")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "text-none ml-5",
                              attrs: {
                                depressed: "",
                                dark: "",
                                outlined: "",
                                color: _vm.isGood ? "#18b23d" : "#ffa700",
                                to: "/myvps/ordering",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getClientInfo(true)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("btn_order[0]")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.type === "package" && _vm.isGood
                    ? _c(
                        "v-flex",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { "pb-3": "" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "text-none mr-5",
                              attrs: {
                                depressed: "",
                                dark: "",
                                color: _vm.isGood ? "#18b23d" : "#ffa700",
                                to: "/invoice-detail/" + _vm.invoiceId,
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("btn_details[0]")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "text-none ml-5",
                              attrs: {
                                depressed: "",
                                dark: "",
                                outlined: "",
                                color: _vm.isGood ? "#18b23d" : "#ffa700",
                              },
                              on: { click: _vm.linkToPage },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("btn_check[0]")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }